import {
  Button,
  Grid,
  Box,
  IconButton,
  Stack,
  Typography,
  TextField as MuiTextField,
  Radio,
  Input
} from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, request, toast } from '../../../../../utils';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import dayjs from 'dayjs';

const TABLE_HEADER = [
  {
    header: 'Employee Name',
    accessor: (row) => `${row?.personalInfo?.firstName} ${row?.personalInfo?.lastName}`
  }
];

export const SalaryDetailsForm = ({ onClose,  onAdd }) => {
  const [input, setInput] = useState('');
  const [detailList, setDetailList] = useState([]);
  const [month, setMonth] = useState(dayjs().month());
  const [year, setYear] = useState(dayjs().year()); 
  const [salaryDetails, setSalaryDetails] = useState([]);
  const[loading,setLoading] = useState(false)

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape()
    ),
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = async (formValues) => {
    console.log(formValues,"FORMVALUES")
    setLoading(true);
    try{
      const response = await axios.post(`${BASE_URL}/payroll/${salaryDetails._id}/${year}/${month + 1}`,formValues);
    
      if (response?.data?.success) {
        toast(`Successfully Created Salary`, { variant: 'success' });
      } else {
        toast(`Failed to  Create Salary`, { variant: 'error' });
      }
      setLoading(false);
    }catch(error){
    console.log(error.message)
    toast(`${error?.response?.data?.message}`, { variant: 'error' });
    }
  };

  useEffect(() => {
    fetchEmployeeList();
  }, [input]);

  const fetchEmployeeList = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const response = await request('/employee-list', {
        method: 'GET',
        query: {  name: lowercasedInput }
      });
      if (response.success && Array.isArray(response.data)) {
        setDetailList({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setDetailList({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setDetailList({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    fetchEmployeeList();
  }, []);

  const handleInputChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const fetchSalaryDetailsData = async (employee) => {
    try {
      const response = await fetch(`${BASE_URL}/calculate-salary/${employee._id}/${year}/${month + 1}`);
      if (!response.ok) {
        console.error('Error fetching data:', response.status, response.statusText);
        return;
      }
      const result = await response.json();
      setValue('total_attendance', result?.data?.presentDays || 0);
      setValue('gross_salary', Math.round(result?.data?.grossSalary) || 0);
      setValue('net_salary', Math.round(result?.data?.netSalary) || 0);
      setValue('basic', Math.round(result?.data?.baseSalary) || 0);
      setValue('da', Math.round(result?.data?.daAmount) || 0);
      setValue('hra', Math.round(result?.data?.hraAmount) || 0);
      setValue('tds', Math.round(result?.data?.monthlyTax) || 0);
      setValue('esi', Math.round(result?.data?.esiAmount) || 0);
      setValue('pf', Math.round(result?.data?.pfAmount) || 0);
      setValue('leave', Math.round(result?.data?.absentDays) || 0);
      setValue('per_visit_rate', Math.round(result?.data?.perVisitRate) || 0);
      return { employeeId: employee._id, attendanceData: result };
    } catch (error) {
      console.error('Error fetching attendance data:', error);
    }
  };

  useEffect(() => {
    fetchSalaryDetailsData();
  }, [month, year]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Staff Salary
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={5} 
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
              <MuiTextField
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    padding: '0',
                    fontSize: '14px',
                    fontWeight: '700'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px'
                  }
                }}
                label="Search Employees"
                variant="outlined"
                value={input}
                onChange={handleInputChange}
                InputProps={{
                  style: {
                    fontSize: '14px',
                    fontWeight: 600
                  }
                }}
              />
            </Stack>
            <Table
              containerSX={{
                flex: 1,
                border: '0px solid rgba(0,0,0,0.27)',
                minHeight: '48rem',
                borderRadius: 1
              }}
              data={detailList?.data || []}
              columns={TABLE_HEADER}
              size="small"
              onRowClick={(row) => {
                fetchSalaryDetailsData(row);
                setSalaryDetails(row);
              }}
            />
          </Grid>
          <Grid container item xs={7} direction="row" spacing={2}>
            <Grid item xs={12} sx={{ marginBottom: salaryDetails === 'Permanent' ? -1 : -10 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', flex: 0.2 }}>Total Attendance</Typography>
                <TextField sx={{ flex: 0.8 }} name="total_attendance" placeholder="Total Attendance" />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', flex: 0.2 }}>Gross Salary</Typography>
                <TextField sx={{ flex: 0.8 }} name="gross_salary" placeholder="Gross Salary" />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', flex: 0.2 }}>Net Salary</Typography>
                <TextField sx={{ flex: 0.8 }} name="net_salary" placeholder="Net Salary" />
              </Box>
            </Grid>

            {salaryDetails?.salaryDetails?.salaryType === 'Permanent' && (
              <>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
                    <Typography
                      color="primary"
                      sx={{ fontWeight: 700, fontSize: '1.8rem', textDecoration: 'underline' }}
                    >
                      Earnings
                    </Typography>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Basic</Typography>
                      <TextField sx={{ flex: 0.8 }} name="basic" placeholder="Basic" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>DA</Typography>
                      <TextField sx={{ flex: 0.8 }} name="da" placeholder="DA" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>HRA</Typography>
                      <TextField sx={{ flex: 0.8 }} name="hra" placeholder="HRA" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Conveyance</Typography>
                      <TextField sx={{ flex: 0.8 }} name="conveyance" placeholder="Conveyance" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Allowance</Typography>
                      <TextField sx={{ flex: 0.8 }} name="allowance" placeholder="Allowance" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Medical Allowance</Typography>
                      <TextField
                        sx={{ flex: 0.8 }}
                        name="medical_allowance"
                        placeholder="Medical Allowance"
                        type="number"
                      />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Others</Typography>
                      <TextField sx={{ flex: 0.8 }} name="others" placeholder="Others" type="number" />
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
                    <Typography
                      color="primary"
                      sx={{ fontWeight: 700, fontSize: '1.8rem', textDecoration: 'underline' }}
                    >
                      Deductions
                    </Typography>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>TDS</Typography>
                      <TextField sx={{ flex: 0.8 }} name="tds" placeholder="TDS" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>ESI</Typography>
                      <TextField sx={{ flex: 0.8 }} name="esi" placeholder="ESI" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>PF</Typography>
                      <TextField sx={{ flex: 0.8 }} name="pf" placeholder="PF" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Leave</Typography>
                      <TextField sx={{ flex: 0.8 }} name="leave" placeholder="Leave" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Prof. Tax</Typography>
                      <TextField sx={{ flex: 0.8 }} name="prof_tax" placeholder="Prof. Tax" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Labour Welfare</Typography>
                      <TextField sx={{ flex: 0.8 }} name="labour_welfare" placeholder="Labour Welfare" type="number" />
                    </Stack>
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Others</Typography>
                      <TextField sx={{ flex: 0.8 }} name="deductions_others" placeholder="Others" type="number" />
                    </Stack>
                  </Box>
                </Grid>
              </>
            )}
            {salaryDetails?.salaryDetails?.salaryType === 'Per Visit' && (
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
                  <Typography color="primary" sx={{ fontWeight: 700, fontSize: '1.8rem', textDecoration: 'underline' }}>
                    Earnings
                  </Typography>
                  <Stack spacing={1} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Per Visit Rate</Typography>
                    <TextField sx={{ flex: 0.8 }} name="per_visit_rate" placeholder="Per Visit Rate" type="number" />
                  </Stack>
                  <Stack spacing={1} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Leave</Typography>
                    <TextField sx={{ flex: 0.8 }} name="leave" placeholder="Leave" type="number" />
                  </Stack>
                </Box>
              </Grid>
            )}
            <Stack
              spacing={1}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ mt: 2, width: '100%' }}
            >
              <Button variant="contained" type="submit">
                Add
              </Button>
              <Button variant="outlined" onClick={onClose} color="error">
                Close
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
